var React = require('react');

function CloseButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.679688 2.89356L2.89356 0.679688L12.4863 10.2724L22.1083 0.679688L24.3222 2.89356L14.7002 12.4863L24.3222 22.1083L22.1083 24.3222L12.4863 14.7002L2.89356 24.3222L0.679688 22.1083L10.2724 12.4863L0.679688 2.89356Z","fill":"#171717"}));
}

CloseButton.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = CloseButton;

CloseButton.default = CloseButton;
